


































































import Vue from 'vue'
import { BUNNY_STORAGE } from '../utils/bunny-storage'

export default Vue.extend({
  name: 'Notes',

  data() {
    const notes = localStorage.getItem(BUNNY_STORAGE)
      ? JSON.parse(localStorage.getItem(BUNNY_STORAGE)!)
      : []
    return {
      notes
    }
  }
})
